module.exports = __webpack_public_path__ + "img/2025-02-13c_2.c21f9504.jpg";